import LensIntelligence from '../components/LensIntelligence';
import Pageheader from '../utils/headerHelment';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isLensIntelligenceEnabled } from '../utils/lensFeatures';
import styles from '../components/LensIntelligence/lensIntelligence.module.css';

const LensIntelligenceView = () => {
    const { selectedProject } = useSelector(state => state.projectData);

    if (!isLensIntelligenceEnabled(selectedProject)) {
        return <Navigate to="/project" replace />;
    }

    return (
        <div className={styles.pageRoot}>
            <Pageheader title="LENS - Lens Intelligence" />
            <LensIntelligence />
        </div>
    );
};

export default LensIntelligenceView;
